/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Legal_Content_Identity_TitleInputs */

const fr_legal_content_identity_title = /** @type {(inputs: Legal_Content_Identity_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contenus & Identité Visuelle`)
};

const en_legal_content_identity_title = /** @type {(inputs: Legal_Content_Identity_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Content & Visual Identity`)
};

/**
* | output |
* | --- |
* | "Content & Visual Identity" |
*
* @param {Legal_Content_Identity_TitleInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const legal_content_identity_title = /** @type {((inputs?: Legal_Content_Identity_TitleInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Legal_Content_Identity_TitleInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_legal_content_identity_title(inputs)
	return en_legal_content_identity_title(inputs)
});